import type { PathArray } from "common/utils/formStructure";
import { Section } from "../../../../../../../Common/Layout";
import { FieldActions } from "./FieldActions";
import { FieldPermissions } from "./FieldPermissions";

type FieldPreviewFooterProps = {
  fieldPath: PathArray;
  isGroup?: boolean;
};

export function FieldPreviewFooter({
  fieldPath,
  isGroup,
}: FieldPreviewFooterProps) {
  return (
    <footer>
      <Section
        flexDirection="row"
        style={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <div style={{ flexGrow: 1 }}>
          {!isGroup && <FieldPermissions fieldPath={fieldPath} />}
        </div>
        <FieldActions fieldPath={fieldPath} isGroup={isGroup} />
      </Section>
    </footer>
  );
}
